/* Rincón del Valle — Page Experience helper — 2026-06-02
   Conservative: keeps features, reduces input blocking and reserves late widget layout. */
(function () {
  if (window.__rdvPerformanceHelper) return;
  window.__rdvPerformanceHelper = true;

  var doc = document;
  var root = doc.documentElement;
  root.classList.add('rdv-performance-helper');

  function onReady(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function onIdle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: timeout || 2500 });
    } else {
      window.setTimeout(fn, timeout || 800);
    }
  }

  function setAttrs(el, attrs) {
    if (!el) return;
    Object.keys(attrs).forEach(function (key) {
      if (!el.hasAttribute(key) || !el.getAttribute(key)) el.setAttribute(key, attrs[key]);
    });
  }

  function stabilizeMedia() {
    var imgs = doc.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (!img.hasAttribute('loading') && !img.closest('.product__media, .banner, .slideshow, .rdv-popup')) {
        img.setAttribute('loading', 'lazy');
      }
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      if (!img.hasAttribute('width') && img.naturalWidth) img.setAttribute('width', img.naturalWidth);
      if (!img.hasAttribute('height') && img.naturalHeight) img.setAttribute('height', img.naturalHeight);
    });

    doc.querySelectorAll('iframe').forEach(function (iframe) {
      if (!iframe.hasAttribute('loading')) iframe.setAttribute('loading', 'lazy');
      if (!iframe.hasAttribute('title')) iframe.setAttribute('title', 'Contenido integrado');
    });
  }

  function stabilizeWidgets() {
    var selectors = [
      '#fsb_background',
      '#carthike-chat-button-container',
      '#ecom-toast',
      '.jdgm-widget',
      '.shopify-app-block',
      '[class*="chat-button"]',
      '[id*="chat-button"]'
    ];
    selectors.forEach(function (selector) {
      doc.querySelectorAll(selector).forEach(function (el) {
        el.setAttribute('data-rdv-layout-stable', 'true');
      });
    });
  }

  function deferNonCriticalIframes() {
    doc.querySelectorAll('iframe[src]').forEach(function (iframe) {
      var src = iframe.getAttribute('src') || '';
      if (/youtube|vimeo|maps|judge|reviews|chat|klaviyo/i.test(src)) {
        iframe.setAttribute('loading', 'lazy');
      }
    });
  }

  function observeLateMedia() {
    if (!('MutationObserver' in window)) return;
    var scheduled = false;
    var runs = 0;
    var mo = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes || [], function (n) {
          return n.nodeType === 1 && (n.matches?.('img, iframe, #fsb_background, #carthike-chat-button-container, #ecom-toast, .shopify-app-block') || n.querySelector?.('img, iframe'));
        });
      });
      if (!shouldRun || scheduled || runs > 4) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        runs += 1;
        stabilizeMedia();
        if (runs <= 2) stabilizeWidgets();
        deferNonCriticalIframes();
      }, 350);
    });
    mo.observe(doc.body || doc.documentElement, { childList: true, subtree: true });
    window.setTimeout(function(){ try { mo.disconnect(); } catch(e){} }, 9000);
  }

  function markFirstInteraction() {
    var done = false;
    function mark() {
      if (done) return;
      done = true;
      root.classList.add('rdv-user-interacted');
      window.removeEventListener('pointerdown', mark, true);
      window.removeEventListener('keydown', mark, true);
      window.removeEventListener('touchstart', mark, true);
      window.removeEventListener('scroll', mark, true);
    }
    window.addEventListener('pointerdown', mark, { capture: true, passive: true });
    window.addEventListener('keydown', mark, { capture: true });
    window.addEventListener('touchstart', mark, { capture: true, passive: true });
    window.addEventListener('scroll', mark, { capture: true, passive: true, once: true });
  }

  onReady(function () {
    stabilizeWidgets();
    markFirstInteraction();
    onIdle(function () {
      stabilizeMedia();
      deferNonCriticalIframes();
      observeLateMedia();
    }, (window.matchMedia && window.matchMedia('(max-width: 749px)').matches && location.pathname === '/') ? 2800 : 1200);
  });
})();

/* RDV SEO/accessibility 2026-06-19: fallback ALT for client-rendered menu/app images */
(function(){
  if (window.__rdvAltFallback) return;
  window.__rdvAltFallback = true;
  function cleanText(value){
    return (value || '').replace(/\s+/g, ' ').trim().slice(0, 140);
  }
  function fromFilename(src){
    try {
      var path = new URL(src, window.location.href).pathname.split('/').pop() || '';
      path = path.replace(/\.(jpg|jpeg|png|webp|gif|svg)$/i, '').replace(/[-_]+/g, ' ');
      path = path.replace(/\b(Rincon del Valle|Rincon DV|Rinc[oó]n del Valle|\d{5,}|v=\d+)\b/ig, '');
      return cleanText(path);
    } catch(e) { return ''; }
  }
  function labelFor(img){
    var labelled = img.closest('[aria-label]');
    var link = img.closest('a, button');
    var title = img.getAttribute('title') || img.getAttribute('data-alt') || '';
    return cleanText(title) || cleanText(link && link.innerText) || cleanText(labelled && labelled.getAttribute('aria-label')) || fromFilename(img.currentSrc || img.src || '');
  }
  function apply(){
    document.querySelectorAll('img:not([alt]), img[alt=""]').forEach(function(img){
      var label = labelFor(img);
      if (label) img.setAttribute('alt', label);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  window.addEventListener('load', apply, { once: true });
})();

